import React from 'react'
import ReactDOM from 'react-dom'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'

import { fetchDetailsQuote } from '../actions/quotes'
import { setPickup } from '../actions/shipback'

import { PICKUP, COMPUTED } from '../assets/constant'
import { isEmpty , pad} from '../assets/utils'

class PickupSlot extends React.Component {

  selectSlot(pickup_datetime, pickup_duration, pickup_slot_id, time) {
    this.props.selectPickup(pickup_datetime, pickup_duration, pickup_slot_id, time)
  }

  renderTime(date, slot) {
    var timeParts = slot.start_time.split(':')
    var hours = timeParts[0]
    var minutes = timeParts[1]
    var dateCompare = date.split('-')
    var newDate = dateCompare[2].split(' ')[0] + "/" + dateCompare[1] + "/" + dateCompare[0]
    var endDate = new Date(date)
    endDate.setHours(Number(hours))
    endDate.setMinutes(Number(minutes) + Number(slot.duration))
    return (
      <label value={date.trim() + ' ' + slot.start_time} className="slot-label">
        <input
          type="radio"
          name="pickup_datetime"
          value={date.trim() + ' ' + slot.start_time}
          checked={(this.props.activeTime == slot.start_time && this.props.activeDate.toLocaleDateString() == newDate) ? "checked" : ""}
          onChange={(e) => this.selectSlot(e.target.value, slot.duration, slot.id, slot.start_time)}/>
        <span>{hours + ":" + minutes} - {endDate.getHours() + ":" + pad(endDate.getMinutes())}</span>
      </label>
      )
  }

  render() {
    var dateParts = this.props.slot.date.split('-')
    var date = new Date(dateParts[0], dateParts[1]-1, dateParts[2]);
    var slotClass = date.toLocaleDateString() == this.props.activeDate.toLocaleDateString() ? "slot show" : "slot"
    return(
       <div className={slotClass}>
        <ul>
          { this.props.slot.slots.map((slots, index) => (
            <li key={this.props.slot.date + slots.start_time}>
              {this.renderTime(this.props.slot.date, slots)}
            </li>
          ))}
        </ul>
      </div>
    )
  }
}

class PickupDate extends React.Component {

  render() {
    var dateParts = this.props.date.split('-')
    var date = new Date(dateParts[0], dateParts[1]-1, dateParts[2]);
    var days = I18n.t('date.day_names')
    var months =  I18n.t('date.abbr_month_names')
    var today = new Date();
    var tomorrow = new Date(today.getTime() + (24 * 60 * 60 * 1000));
    var dayClass = date.toLocaleDateString() == this.props.activeDate.toLocaleDateString() ?  "day active" : "day"

    return (
      <div className="col-12 col-sm-4 col-md-2 p-1">
        <div className={dayClass} onClick={() => this.props.selectDate(date)}>
          <div className="row">
            <span className="col-3  offset-1 col-sm-12 offset-sm-0 day-of-week">
              {days[date.getDay()]}
            </span>
            <span className="col-2 col-sm-12 day-of-month">
               {date.getDate()}
            </span>
            <span className="col-3 col-sm-12 month">
               {months[date.getMonth() + 1]}
            </span>
            <span className="col-3 col-sm-12 relative">
              { date.toLocaleDateString() == today.toLocaleDateString() ?
                I18n.t('shipbacks.modes.pickups.show.days.today') : <div></div>
              }
              { date.toLocaleDateString() == tomorrow.toLocaleDateString() ?
                I18n.t('shipbacks.modes.pickups.show.days.tomorrow') : <div></div>
              }
            </span>
          </div>
        </div>
      </div>
    )
  }
}

var interval = 0

class Pickup extends React.Component {

  constructor(props) {
    super()
    this.props = props
    var today = new Date()
    this.selectDate = this.selectDate.bind(this)
    this.selectTime = this.selectTime.bind(this)
    this.selectPickup = this.selectPickup.bind(this)
    this.state = {activeDate: today}
    if (this.props.pickup == undefined) {
      this.props.fetchDetailsQuote(shipback_id, "pickup", this.props.user_token)
    }
  }

  selectPickup(pickup_datetime, pickup_duration, pickup_slot_id, time) {
    this.selectTime(time)
    this.props.setPickup(pickup_datetime, pickup_duration, pickup_slot_id, shipback_id, this.props.user_token)
  }

  selectDate(date) {
    this.setState({activeDate: date, activeTime: null})
  }
  selectTime(time) {
    this.setState({activeTime: time})
  }

  componentWillMount() {
    interval = setInterval(() => { this.initPickup() }, 200)
  }

  initPickup() {
    if (this.props.pickup != undefined && this.props.pickup.state == COMPUTED) {
      if (this.props.shipback.pickup_datetime != null) {
        var dateSplit = this.props.shipback.pickup_datetime.split(' ')
        var dateParts = dateSplit[0].split('-')
        var date = new Date(dateParts[0], dateParts[1]-1, dateParts[2]);
        this.setState({activeDate: date, activeTime: dateSplit[1]})
      }
      clearInterval(interval)
    }
  }

  componentWillUnmount() {
    clearInterval(interval)
  }

  render() {
    if (!isEmpty(this.props.pickup) && this.props.pickup.mode == PICKUP && this.props.pickup.state == COMPUTED) {
      return (
        <div className="row modes">
          <div className="col-10 offset-1">
          <h2>{I18n.t('shipbacks.modes.pickups.show.title')}</h2>
          <div id="timetable">
            <h3>{I18n.t('shipbacks.modes.pickups.show.date_title')}</h3>
            <div id="days" className="days d-flex flex-wrap row">
              {
                this.props.pickup.pickup_slots.map((slot) => (
                  <PickupDate
                    key={slot.date}
                    date={slot.date}
                    activeDate={this.state.activeDate}
                    selectDate={this.selectDate} />
                  ))
              }
            </div>
            <h3>{I18n.t('shipbacks.modes.pickups.show.slots_title')}</h3>
            <div className="slots">
              {
                this.props.pickup.pickup_slots.map((slot, index) => (
                  <PickupSlot
                    key={slot.date}
                    slot={slot} index={index}
                    activeDate={this.state.activeDate}
                    activeTime={this.state.activeTime}
                    selectPickup={this.selectPickup}
                    selectTime={this.selectTime} />
                  ))
              }
            </div>
          </div>
        </div>
      </div>
      )
    } else {
      return (
        <div className="row spinner">
          <div className="col-12">
             <i className="fa-li fa fa-3x fa-spinner fa-spin"/>
            <h3>{I18n.t('shipbacks.modes.pickups.show.loading')}</h3>
          </div>
        </div>
      )
    }
  }
}

const mapStateToProps = state => ({
 shipback: state.shipback,
 pickup: state.quotes.pickup,
 user_token: state.user
})

const mapDispatchToProps = dispatch => bindActionCreators({ fetchDetailsQuote, setPickup }, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(Pickup)


// WEBPACK FOOTER //
// ./app/javascript/components/components/Pickup.jsx